/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tree_Type_135_TitleInputs */

const en_tree_type_135_title = /** @type {(inputs: Tree_Type_135_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bird of Paradise`)
};

const ar_tree_type_135_title = /** @type {(inputs: Tree_Type_135_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`طائر الجنة`)
};

const de_tree_type_135_title = /** @type {(inputs: Tree_Type_135_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paradiesvogel`)
};

const es_tree_type_135_title = /** @type {(inputs: Tree_Type_135_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ave del paraíso`)
};

const fr_tree_type_135_title = /** @type {(inputs: Tree_Type_135_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oiseau de Paradis`)
};

const it_tree_type_135_title = /** @type {(inputs: Tree_Type_135_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uccello del Paradiso`)
};

const ja_tree_type_135_title = /** @type {(inputs: Tree_Type_135_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ゴクラクチョウカ`)
};

const ko_tree_type_135_title = /** @type {(inputs: Tree_Type_135_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`극락조화`)
};

const pt_br_tree_type_135_title = /** @type {(inputs: Tree_Type_135_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ave-do-paraíso`)
};

const ru_tree_type_135_title = /** @type {(inputs: Tree_Type_135_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стрелиция королевская`)
};

const th_tree_type_135_title = /** @type {(inputs: Tree_Type_135_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปักษาสวรรค์`)
};

const tr_tree_type_135_title = /** @type {(inputs: Tree_Type_135_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cennet Kuşu`)
};

const zh_cn_tree_type_135_title = /** @type {(inputs: Tree_Type_135_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`天堂鸟`)
};

const zh_tw_tree_type_135_title = /** @type {(inputs: Tree_Type_135_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`天堂鳥`)
};

/**
* | output |
* | --- |
* | "Bird of Paradise" |
*
* @param {Tree_Type_135_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const tree_type_135_title = /** @type {((inputs?: Tree_Type_135_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tree_Type_135_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tree_type_135_title(inputs)
	if (locale === "ar") return ar_tree_type_135_title(inputs)
	if (locale === "de") return de_tree_type_135_title(inputs)
	if (locale === "es") return es_tree_type_135_title(inputs)
	if (locale === "fr") return fr_tree_type_135_title(inputs)
	if (locale === "it") return it_tree_type_135_title(inputs)
	if (locale === "ja") return ja_tree_type_135_title(inputs)
	if (locale === "ko") return ko_tree_type_135_title(inputs)
	if (locale === "pt_br") return pt_br_tree_type_135_title(inputs)
	if (locale === "ru") return ru_tree_type_135_title(inputs)
	if (locale === "th") return th_tree_type_135_title(inputs)
	if (locale === "tr") return tr_tree_type_135_title(inputs)
	if (locale === "zh_cn") return zh_cn_tree_type_135_title(inputs)
	return zh_tw_tree_type_135_title(inputs)
});